import {
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
} from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { JwtInterceptor } from "@auth0/angular-jwt";
import { Store } from "@ngxs/store";
import { Observable } from "rxjs";
import { mergeMap } from "rxjs/operators";
import { StoredAuthUserRefreshTokenAction } from "../state/stored-auth.actions";
import { StoredAuthState } from "../state/stored-auth.state";

@Injectable({
	providedIn: "root",
})
export class RefreshTokenInterceptor implements HttpInterceptor {
	private store = inject(Store);
	private jwtInterceptor = inject(JwtInterceptor);

	// No constructor needed when using inject

	intercept(
		request: HttpRequest<unknown>,
		next: HttpHandler,
	): Observable<HttpEvent<unknown>> {
		const token = this.store.selectSnapshot(StoredAuthState.authIdToken);

		if (request.url.indexOf("refresh-token") !== -1) {
			return next.handle(request);
		}

		if (
			this.jwtInterceptor.isAllowedDomain(request) &&
			!this.jwtInterceptor.isDisallowedRoute(request)
		) {
			if (!this.jwtInterceptor.jwtHelper.isTokenExpired(token)) {
				return next.handle(request);
			}
			return this.store.dispatch(new StoredAuthUserRefreshTokenAction()).pipe(
				mergeMap(() => {
					return this.jwtInterceptor.intercept(request, next);
				}),
			);
		} else {
			return next.handle(request);
		}
	}
}
